import ParameterErrors from '../errors/ParameterErrors';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import eventEnable from '../core/eventEnable';
const {throwNotProvided, throwNotOfType}=ParameterErrors;
export default class HouseType{
	static get _ALLOWED_NAME_SEPERATORS(){
		return [' ', '_', '-', ''];
	}
	constructor(props){
		const{slug, name, imageRelativePath, getSiteJson, configuration, nBedrooms, nBathrooms, about, offers, sqrft}=props;
		eventEnable(this);
		enableAcceptBindings(this);
		if(nBedrooms===undefined||nBedrooms===null)
			throwNotProvided('nBedrooms');
		
		if(typeof(nBedrooms)!=='number')
			throwNotOfType('nBedrooms', 'number');
		this._nBedrooms = nBedrooms;
		this._nBathrooms = nBathrooms;
		this._about = about;
		this._getSiteJson =getSiteJson;
		this._configuration = configuration;
		this._slug = slug;
		this._name = name;
		this._offers = offers;
		this._sqrft = sqrft;
		this._imageRelativePath = imageRelativePath;
		this._allPossibleLowerCaseStrings = HouseType._getAllPossibleLowerCaseStrings(name);
		this._configuratorUrl = null;
		this._tourUrl = null;
		this._videoUrl = null;
		this._features = [];
		exposeBinding(this, 'tourUrl', ()=>this.tourUrl, (value)=>this.tourUrl = value);
		exposeBinding(this, 'configuratorUrl', ()=>this.configuratorUrl, (value)=>this.configuratorUrl = value);
		this._statuses = null;
		exposeBinding(this, 'statuses', ()=>this.statuses, (value)=>this.statuses = value, true);
		exposeBinding(this, 'videoUrl', ()=>this.videoUrl, (value)=>this.videoUrl = value, true);
		exposeBinding(this, 'features', ()=>this.features, (value)=>this.features = value);
		exposeBinding(this, 'galleryUrl', ()=>this.galleryUrl, (value)=>this.galleryUrl = value);
		exposeBinding(this, 'chooseYourStyleVideoUrl', ()=>this.chooseYourStyleVideoUrl, (value)=>this.chooseYourStyleVideoUrl = value);
		exposeBinding(this, 'chooseYourStyleIframeUrl', ()=>this.chooseYourStyleIframeUrl, (value)=>this.chooseYourStyleIframeUrl = value);
		exposeBinding(this, 'floorPlansIframeUrl', ()=>this.floorPlansIframeUrl, (value)=>this.floorPlansIframeUrl = value);
	}
	get allPossibleLowerCaseStrings(){
		return this._allPossibleLowerCaseStrings;
	}
	getDescription(){
		return this._name;
	}
	get name(){
		return this._name;
	}
	get slug(){
		return this._slug;
	}
	get brochureEnabled(){
		return this._brochureEnabled;
	}
	get offers(){
		return this._offers;
	}
	set offers(value){
		this._offers = value;
	}
	get sqrft(){
		return this._sqrft;
	}
	set sqrft(value){
		this._sqrft = value;
	}
	set brochureEnabled(value){
		this._brochureEnabled = value;
	}
	get configuratorUrl(){
		return this._configuratorUrl;
	}
	set configuratorUrl(value){
		this._configuratorUrl = value;
	}
	get tourUrl(){
		return this._tourUrl;
	}
	get statuses(){
		return this._statuses;
	}
	set tourUrl(value){
		const changed = this._tourUrl!==value
		if(!changed)return;
		this._tourUrl = value;
		this.bindingsHandler.changed('tourUrl', value);
	}
	get videoUrl(){
		return this._videoUrl;
	}
	set videoUrl(value){
		const changed = this._videoUrl!==value
		if(!changed)return;
		this._videoUrl = value;
		this.bindingsHandler.changed('videoUrl', value);
	}
	get galleryUrl(){
		return this._galleryUrl;
	}
	set galleryUrl(value){
		console.log('SETTTING GALLERY URL');
		if(this._galleryUrl===value)
			return;
		this._galleryUrl = value;
		this.bindingsHandler.changed('galleryUrl', value);
	}
	get chooseYourStyleVideoUrl(){
		return this._chooseYourStyleVideoUrl;
	}
	set chooseYourStyleVideoUrl(value){
		if(this._chooseYourStyleVideoUrl===value)
			return;
		this._chooseYourStyleVideoUrl = value;
		this.bindingsHandler.changed('chooseYourStyleVideoUrl', value);
	}
	get chooseYourStyleIframeUrl(){
		return this._chooseYourStyleIframeUrl;
	}
	set chooseYourStyleIframeUrl(value){
		if(this._chooseYourStyleIframeUrl===value)
			return;
		this._chooseYourStyleIframeUrl = value;
		this.bindingsHandler.changed('chooseYourStyleIframeUrl', value);
	}
	get floorPlansIframeUrl(){
		return this._floorPlansIframeUrl;
	}
	set floorPlansIframeUrl(value){
		if(this._floorPlansIframeUrl===value)
			return;
		this._floorPlansIframeUrl = value;
		this.bindingsHandler.changed('floorPlansIframeUrl', value);
	}
	get plots(){
		return this._getSiteJson().getPlotsForHouseType(this);
	}
	getImageAbsolutePath(){
		return `${Urls.getAssetsForSite(this._configuration.siteSlug)}${UrlHelper.removeStartSlash(this._imageRelativePath)}`;
	}
	get features(){
		return this._features;
	}
	set features(value){
		this._features= value;
		this.bindingsHandler.changed('features');
		this.dispatchEvent({type:'featureschanged', features:this._features});
	}
	get nBedrooms(){
		return this._nBedrooms;
	}
	set nBedrooms(value){
		this._nBedrooms = value;
	}
	get nBathrooms(){
		return this._nBathrooms;
	}
	get about(){
		return this._about;
	}
	static _getAllPossibleLowerCaseStrings(name){
		name = name.toLowerCase();
		const allowedNameSeperators = HouseType._ALLOWED_NAME_SEPERATORS;
		const nameComponents = name.split(new RegExp('['+allowedNameSeperators.join('')+']'));
		if(nameComponents.length<1)return name;
		const strs=[];
		allowedNameSeperators.forEach((seperator)=>{
			let str='';
			nameComponents.forEach(nameComponent=>str+=nameComponent);
			strs.push(str);
		});
		return strs;
	}
	static fromJSON(jObject, getSiteJson, configuration){
		return new HouseType({
			slug:jObject.slug,
			name:jObject.name,
			imageRelativePath:jObject.imageRelativePath,
			getSiteJson,
			configuration,
			nBedrooms:jObject.nBedrooms,
			offers:jObject.offers,
			sqrft:jObject.sqrft,
			nBathrooms:jObject.nBathrooms,
			about:jObject.about
		});
	}
}